import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  inject,
  Inject,
  OnInit,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FooterComponent } from '@rd/core/components/footer/footer.component';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';
import { BRAND_NAME } from '@rd/core/tokens/rd-lib.token';
import { filter } from 'rxjs/operators';
import { RewardsProgramSchemes } from '../../../rewards-program/types';
import { RewardsProgramsViewFacade } from '../../../rewards-program/views/facade/rewards-program-view.facade';
import {
  BNZ_BANKWIDE_UPDATES_ENABLED,
  BNZ_BANK_WIDE_ENABLED,
} from '../../tokens/features.tokens';

@UntilDestroy()
@Component({
  selector: 'bnz-core-main-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BnzFooterComponent extends FooterComponent implements OnInit {
  @HostBinding('class.bnz-core-main-footer') componentClass = true;

  faqsUrl = '/faq';
  contactUsUrl = '/contact_us';
  tncsUrl = '/terms_and_conditions';
  privacyPolicyUrl = '/privacy_policy';

  selectedScheme$ = this.rewardsProgramViewFacade.selectedScheme$;

  readonly BnzRewardsProgramSchemes = RewardsProgramSchemes;

  ascendaImageUrl = this.urlUtilsService.imageUrl(
    '/images/branding/logo-ascenda-blue.png',
  );

  isBankwideEnabled = inject(BNZ_BANK_WIDE_ENABLED);
  isBnzBankwideUpdatesEnabled = inject(BNZ_BANKWIDE_UPDATES_ENABLED);

  constructor(
    @Inject(BRAND_NAME) public brandName: string,
    private rewardsProgramViewFacade: RewardsProgramsViewFacade,
    protected urlUtilsService: UrlUtilsService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
  ) {
    super(brandName, urlUtilsService);
  }

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        untilDestroyed(this),
      )
      .subscribe(() => {
        this.cdRef.markForCheck();
      });
  }

  getCurrentYear(): { currentYear: number } {
    return { currentYear: new Date().getFullYear() };
  }

  // Hide footer on mobile
  // Only on Offer Listing page but not on Offer details page
  // On rewards program linking account page
  shouldHideFooter(): boolean {
    const ROUTE_URLS = ['/offers', '/rewards_programs/link_flybuys_account'];
    const routeUrlWithoutParameter = this.router.url.split('?')[0];

    const hiddenRoute = !!ROUTE_URLS.find(
      (url) => url === routeUrlWithoutParameter,
    );

    return hiddenRoute;
  }

  get rewardProgrammeTnCUrl(): string {
    return this.isBnzBankwideUpdatesEnabled
      ? 'http://bnz.co.nz/rewardsterms'
      : 'https://www.bnz.co.nz/about-us/governance/terms-and-conditions#cards';
  }
}
